import React from 'react';
import { Button } from '@mui/material';

export const Columns = (deleteItem) => [
  {
    id: 'code',
    numeric: true,
    disablePadding: false,
    label: 'Mã',
    align: 'center',
  },
  {
    id: 'name',
    numeric: true,
    disablePadding: false,
    label: 'Tên nhóm phụ phí',
    align: 'center',
  },
  {
    id: 'nameEN',
    numeric: true,
    disablePadding: false,
    label: 'Tên nhóm phụ phí (tiếng Anh)',
    align: 'center',
  },
  {
    id: 'nameCN',
    numeric: true,
    disablePadding: false,
    label: 'Tên nhóm phụ phí (tiếng Hoa)',
    align: 'center',
  },
  {
    id: 'nameJP',
    numeric: true,
    disablePadding: false,
    label: 'Tên nhóm phụ phí (tiếng Nhật)',
    align: 'center',
  },
  {
    id: 'serviceName',
    numeric: true,
    disablePadding: false,
    label: 'Dịch vụ',
    align: 'center',
  },
  {
    id: 'subServiceName',
    numeric: true,
    disablePadding: false,
    label: 'Dịch vụ phụ',
    align: 'center',
  },
  {
    id: 'note',
    numeric: true,
    disablePadding: false,
    label: 'Ghi chú',
    align: 'center',
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: false,
    label: 'Thao tác',
    width: '10px',
    fixed: 'right',
    align: 'center',
    render: (row) => (
      <Button
        variant="contained"
        size="small"
        color="error"
        sx={{ borderRadius: '15px', textTransform: 'none' }}
        onClick={() => window.showConfirm(() => deleteItem(row))}
      >
        Xoá
      </Button>
    ),
  },
];
